import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputWithoutValidations";
import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import ErrorImg from "../../../Assets/Images/CommanImages/Warning.png";
import dummyData from "../TipInventoryDummyData.json";
import "../tipinventory.css";
import SelectedTipOfDayTable from "./SelectedTipOfDayTable";
import { GET, POST } from "../../../Api/HttpsMethods";
import EndPoints from "../../../Api/Endpoints";
 
 
const ScheduleTipsOfDays = ({
  dataClient,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) => {
  const navigate = useNavigate();
  const columnDropdownRef = useRef(null);
  const [selectedScheduleType, setSelectedScheduleType] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [scheduleLaunchTime, setScheduleLaunchTime] = useState("");
  const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [isScheduleOpen, setIsScheduleOpen] = useState(true);
  const [isFilterTipOpen, setIsFilterTipOpen] = useState(true);
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [averageRunTime, setAverageRunTime] = useState("");
  const [filters, setFilters] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [scheduledDates, setScheduledDates] = useState({});
  const bulk = true;
  const searchPlaceholder = "Filter Tip Requests...";
  const [selectedTips, setSelectedTips] = useState([]);
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
  const [currentDateTime, setCurrentDateTime] = useState(null);


  const fetchCurrentDateTime = async () => {
    try {
      const url = EndPoints.GET_CURRENT_DATETIME;
      const response = await GET.withToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });

      if (response && response.status === 200 && response.data) {
        setCurrentDateTime({
          date: response.data.current_date,
          time: response.data.current_time,
        });
      }
    } catch (error) {
      console.error("Error fetching current datetime:", error);
      // Fallback to local time if API fails
      const now = new Date();
      setCurrentDateTime({
        date: now.toISOString().split("T")[0],
        time: now.toTimeString().split(" ")[0],
      });
    }
  };

  useEffect(() => {
    fetchCurrentDateTime();
    const interval = setInterval(fetchCurrentDateTime, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchTipOfDayList = async () => {
      try {
        const url = EndPoints.GET_ALL_TIP_OF_DAY;
        const response = await GET.withToken(url, {
          setMessageBox,
          setIsMessageBoxVisible,
          setActiveImg,
          ErrorImg,
        });
 
        if (response && response.status === 200 && response.headers) {
          const allItems = response.headers;
 
          const firstRowIndex = allItems.findIndex(item => Array.isArray(item));
 
          const rawHeaders = allItems.slice(0, firstRowIndex);
          const cleanHeaders = rawHeaders.map(header =>
            header.replace(/^[ntd]\*/, '').trim()
          );
 
          const rows = allItems.slice(firstRowIndex);
 
          const transformedRows = rows.map((row) =>
            row.map((cell, index) => {
              const rawHeader = rawHeaders[index];
              if (rawHeader && rawHeader.startsWith('d*')) {
                if (!cell) return "";
                try {
                  return new Date(cell).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                  });
                } catch {
                  return cell;
                }
              }
              return cell === "" || cell === null || cell === undefined ? "" : cell;
            })
          );
 
          setHeaders(cleanHeaders);
          setReportDashboardData(transformedRows);
        }
      } catch (error) {
        console.error("Error fetching tip of day list:", error);
      }
    };
 
    fetchTipOfDayList();
  }, []);
 
  useEffect(() => {
    setVisibleColumns(headers.slice(0, 5));
  }, [headers]);
 
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnDropdownRef.current &&
        !columnDropdownRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
 
  useEffect(() => {
    const selectedTipIds = selectedTips.map(row => row[0]);
    setSelectedRows(selectedTipIds);
  }, [selectedTips]);
 
  const handleColumnSelection = (column) => {
    setVisibleColumns((prev) =>
      prev.includes(column) ? prev.filter((c) => c !== column) : [...prev, column]
    );
  };
 
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };
 
  const handleApplyFilter = () => {
    if (Object.keys(filters).length > 0) {
      setAppliedFilters({ ...filters });
      setCurrentPage(1);
      setIsFiltersApplied(true);
      setIsFilterVisible(false);
    }
  };
 
  const handleResetFilter = () => {
    setFilters({});
    setAppliedFilters({});
    setAverageRunTime("");
    setIsFiltersApplied(false);
  };
 
  const handleSort = (column) => {
    setSortConfig((prev) => ({
      key: column,
      direction: prev.key === column && prev.direction === "asc" ? "desc" : "asc",
    }));
  };
 
  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };
 
  const handleSelectAll = (e) => {
    if (!bulk) return;
    setSelectedRows(e.target.checked ? reportDashboardData.map((row) => row[0]) : []);
  };
 
  const handleRowSelect = (rowIndex) => {
    const actualIndex = (currentPage - 1) * pageSize + rowIndex;
    const row = reportDashboardData[actualIndex];
    const tipId = row[0];
 
    if (bulk) {
      setSelectedRows((prev) =>
        prev.includes(tipId) ? prev.filter((id) => id !== tipId) : [...prev, tipId]
      );
    } else {
      setSelectedRows([tipId]);
    }
 
    setSelectedTips((prev) => {
      const exists = prev.find((r) => r[0] === tipId);
      return exists ? prev.filter((r) => r[0] !== tipId) : [...prev, row];
    });
  };
 
  const filteredData = reportDashboardData.filter((row) => {
    const matchesSearch =
      searchQuery === "" ||
      row.some((cell) => cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase()));
    const matchesAvgRT = averageRunTime === "" || row[2] === averageRunTime;
    const matchesFilters = Object.entries(appliedFilters).every(([key, value]) => {
      const colIndex = headers.indexOf(key);
      return value ? row[colIndex] === value : true;
    });
    return matchesSearch && matchesAvgRT && matchesFilters;
  });
 
  const sortedData = React.useMemo(() => {
    if (sortConfig.key === null) return filteredData;
    const colIndex = headers.indexOf(sortConfig.key);
    return [...filteredData].sort((a, b) => {
      if (a[colIndex] < b[colIndex]) return sortConfig.direction === "asc" ? -1 : 1;
      if (a[colIndex] > b[colIndex]) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [filteredData, sortConfig, headers]);
 
  const totalPages = Math.ceil(sortedData.length / pageSize);
 
  const paginatedData = React.useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return sortedData.slice(start, start + pageSize);
  }, [sortedData, currentPage, pageSize]);
 
  const renderPagination = () => {
    const pages = [];
    const btn = (i) => (
      <button
        key={i}
        onClick={() => setCurrentPage(i)}
        style={{ borderRadius: "5px" }}
        className={i === currentPage ? "active" : ""}
      >
        {i}
      </button>
    );
    const dots = (k) => (
      <span key={k} style={{ borderRadius: "5px" }}>
        ...
      </span>
    );
 
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(btn(i));
    } else if (currentPage <= 3) {
      [1, 2, 3].forEach((i) => pages.push(btn(i)));
      pages.push(dots("d1"));
      pages.push(btn(totalPages));
    } else if (currentPage > 3 && currentPage < totalPages - 2) {
      pages.push(btn(1));
      pages.push(dots("d1"));
      for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(btn(i));
      pages.push(dots("d2"));
      pages.push(btn(totalPages));
    } else {
      pages.push(btn(1));
      pages.push(dots("d1"));
      for (let i = totalPages - 2; i <= totalPages; i++) pages.push(btn(i));
    }
    return pages;
  };
 
  // ── Extracted save logic ──────────────────────────────────────────────────
  const proceedToSave = async () => {
    try {
      const scheduleData = selectedTips.map((row) => ({
        scheduled_date: scheduledDates[row[0]],
        tip_id: row[0],
      }));
 
      const payload = {
        user_name: userName,
        schedule_data: scheduleData,
      };
 
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Saving schedule...</span>
          </div>
        </div>
      );
 
      const url = EndPoints.CREATE_TIP_OF_THE_DAY_SCHEDULE;
      const response = await POST.withToken(url, payload, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
 
      if (response && response.status === 200) {
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Tip of the Day schedule has been saved successfully!</span>
            </div>
          </div>
        );
        setTimeout(() => {
          setIsMessageBoxVisible(false);
          navigate("/tip_dashboard");
        }, 2000);
        setActiveImg(false)
      } else {
        throw new Error(response?.message || "Failed to save schedule");
      }
    } catch (error) {
      console.error("Error saving schedule:", error);
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Failed to save schedule. Please try again. {error.message}</span>
          </div>
        </div>
      );
    }
  };
 
  // ── Main save handler with validations ───────────────────────────────────
  const handleSave = async () => {
    if (!startDate || !endDate) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select a From Date and To Date before saving.</span>
          </div>
        </div>
      );
      return;
    }
 
    if (new Date(endDate) < new Date(startDate)) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>To Date cannot be earlier than From Date.</span>
          </div>
        </div>
      );
      return;
    }
 
    if (!selectedFrequency) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select a Frequency before saving.</span>
          </div>
        </div>
      );
      return;
    }
 
    if (selectedTips.length === 0) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select at least one tip before saving.</span>
          </div>
        </div>
      );
      return;
    }
 
    const frequencyGapDays = {
      once_in_1_day: 1,
      once_in_2_days: 2,
      once_in_3_days: 3,
      once_in_4_days: 4,
      once_in_5_days: 5,
      once_in_6_days: 6,
      once_in_week: 7,
    };
    const gapDays = frequencyGapDays[selectedFrequency.id] ?? 1;
 
    const unscheduledTips = selectedTips.filter((row) => !scheduledDates[row[0]]);
    if (unscheduledTips.length > 0) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              {unscheduledTips.length} tip(s) do not have a scheduled date assigned.
              Please assign a date to every selected tip.
            </span>
          </div>
        </div>
      );
      return;
    }
 
    const dateCounts = {};
    selectedTips.forEach((row) => {
      const date = scheduledDates[row[0]];
      if (date) dateCounts[date] = (dateCounts[date] || 0) + 1;
    });
    const conflictDates = Object.entries(dateCounts)
      .filter(([, count]) => count > 1)
      .map(([date]) =>
        new Date(date).toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        })
      );
    if (conflictDates.length > 0) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Multiple tips on same date: {conflictDates.join(", ")}. Please select
              different dates for each tip.
            </span>
          </div>
        </div>
      );
      return;
    }
 
    // ── Gap check — warn but allow save ──────────────────────────────────────
    const scheduledDatesList = selectedTips
      .map((row) => scheduledDates[row[0]])
      .filter(Boolean)
      .map((d) => new Date(d))
      .sort((a, b) => a - b);
 
    if (scheduledDatesList.length > 1) {
      const minDate = scheduledDatesList[0];
      const maxDate = scheduledDatesList[scheduledDatesList.length - 1];
 
      const allDatesInRange = [];
      for (let d = new Date(minDate); d <= maxDate; d.setDate(d.getDate() + 1)) {
        allDatesInRange.push(new Date(d).toISOString().split("T")[0]);
      }
 
      const scheduledDateStrings = scheduledDatesList.map((d) =>
        d.toISOString().split("T")[0]
      );
      const missingDates = allDatesInRange.filter(
        (date) => !scheduledDateStrings.includes(date)
      );
 
      if (missingDates.length > 0) {
        const formattedMissing = missingDates.map((date) =>
          new Date(date).toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })
        );
 
        const rangeStart = minDate.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        });
        const rangeEnd = maxDate.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        });
 
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                You have selected date range from <strong>{rangeStart}</strong> to{" "}
                <strong>{rangeEnd}</strong> but no tip is selected for:{" "}
                <strong>{formattedMissing.join(", ")}</strong>. Save anyway?
              </span>
            </div>
            <div
              className="messagebox-insider2"
              style={{ display: "flex", gap: "10px", marginTop: "10px" }}
            >
              <button
                className="messagebox-cancel-btn-ok"
                onClick={async () => {
                  setIsMessageBoxVisible(false);
                  await proceedToSave();
                }}
              >
                OK
              </button>
              <button
                className="messagebox-cancel-btn-ok"
                style={{ width: "80px" }}
                onClick={() => setIsMessageBoxVisible(false)}
              >
                CANCEL
              </button>
            </div>
          </div>
        );
        return;
      }
    }
 
    if (gapDays > 1) {
      const sortedDates = selectedTips
        .map((row) => scheduledDates[row[0]])
        .filter(Boolean)
        .map((d) => new Date(d))
        .sort((a, b) => a - b);
 
      for (let i = 1; i < sortedDates.length; i++) {
        const diffDays = Math.round(
          (sortedDates[i] - sortedDates[i - 1]) / (1000 * 60 * 60 * 24)
        );
        if (diffDays < gapDays) {
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>
                  With &quot;{selectedFrequency.label}&quot;, tips must be at least{" "}
                  {gapDays} day(s) apart. Some tips are scheduled too close together.
                </span>
              </div>
            </div>
          );
          return;
        }
      }
    }
 
    await proceedToSave();
  };
 
  return (
    <div className="create-role-container">
      {/* Top Header */}
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Tip of the Day - Schedule</span>
        <div className="create-test-section-btns-container-ques-paper-dels">
          <button
            className="create-test-section-btn-ques-paper-del"
            onClick={() => navigate(-1)}
          >
            CANCEL
          </button>
          <button
            className="create-test-section-btn-ques-paper-del"
            style={{ marginRight: "0px", boxShadow: "0px 4px 4px 0px #00000040" }}
            onClick={handleSave}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#fa4741";
              e.target.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "#424342";
            }}
          >
            SAVE
          </button>
        </div>
      </div>
 
      {/* SCHEDULE ENGINE Accordion */}
      <div className="display-ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>DATE RANGE & FREQUENCY</label>
          </div>
          <div className="accordion-btn" onClick={() => setIsScheduleOpen((o) => !o)}>
            {isScheduleOpen ? <div className="minus"></div> : <div className="plus">+</div>}
          </div>
        </div>
 
        {isScheduleOpen && (
          <div className="accordion-content">
            <div className="display-test-data-container-ques-paper-del-filter-tags">
              <div className="display-grid-container-ques-paper-del-filter-tags">
                <div className="item2">
                  <FormInputs
                    label="From Date"
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="mm/dd/yyyy"
                   min={currentDateTime?.date || new Date().toISOString().split("T")[0]}
                  />
                </div>
                <div className="item3">
                  <FormInputs
                    label="To Date"
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="mm/dd/yyyy"
                   min={currentDateTime?.date || new Date().toISOString().split("T")[0]}
                  />
                </div>
                <div className="item5">
                  <DropDown
                    label="Frequency"
                    selected={selectedFrequency}
                    setSelected={(opt) => setSelectedFrequency(opt || null)}
                    options={[
                      { label: "Once in a Day", id: "once_in_1_day" },
                      { label: "Once in Two Days", id: "once_in_2_days" },
                      { label: "Once in Three Days", id: "once_in_3_days" },
                      { label: "Once in Four Days", id: "once_in_4_days" },
                      { label: "Once in Five Days", id: "once_in_5_days" },
                      { label: "Once in Six Days", id: "once_in_6_days" },
                      { label: "Once in a Week", id: "once_in_week" },
                    ]}
                    isRequired={true}
                    placeholder="Choose Frequency..."
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
 
      {/* FILTER TIP Accordion */}
      <div className="display-ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>Tip Management</label>
          </div>
        </div>
        {isFilterTipOpen && (
          <div className="accordion-content">
            <div className="heading-table-list-tips">
              <span>TIPS LIST</span>
            </div>
            <div className="selected-tips-content-wrapper">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "81vw",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #6A6A6A",
                    overflow: "hidden",
                  }}
                >
                  <input
                    type="text"
                    placeholder={searchPlaceholder}
                    name="search"
                    className="search-input-ques-dash"
                    onChange={handleSearch}
                  />
                  <div
                    style={{
                      width: "1px",
                      height: "24px",
                      backgroundColor: "#2F2E40",
                      margin: "0 4px",
                    }}
                  />
                  <img src={searchicon} alt="search" className="search-icon-ques-dash" />
                </div>
                <div style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}>
                  Displaying{" "}
                  {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
                  {Math.min(currentPage * pageSize, sortedData.length)} of {sortedData.length}{" "}
                  records |{" "}
                  {["10", "25", "50", "100", "500"].map((size) => (
                    <span
                      key={size}
                      onClick={() => handlePageSizeChange(Number(size))}
                      style={{
                        cursor: "pointer",
                        margin: "0 5px",
                        textDecoration: size === pageSize.toString() ? "none" : "underline",
                        color: size === pageSize.toString() ? "black" : "#337AB7",
                      }}
                    >
                      {size}
                    </span>
                  ))}
                </div>
              </div>
 
              {/* Action Bar */}
              <div
                style={{
                  display: "flex",
                  backgroundColor: "#D6D6D6",
                  marginTop: "9px",
                  borderTop: "1px solid grey",
                  borderBottom: "1px solid grey",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#FFBD20",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    paddingLeft: "8px",
                    width: "90px",
                  }}
                  onClick={() => setIsFilterVisible((v) => !v)}
                >
                  <img src={Filter} style={{ height: "24px", width: "24px" }} alt="filter" />
                  <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
                </div>
 
                {/* Column Selection */}
                <div
                  className="col-tc"
                  style={{
                    marginLeft: "auto",
                    textAlign: "end",
                    marginRight: "8px",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    cursor: "pointer",
                    height: "40px",
                  }}
                  onClick={() => setIsColumnDivVisible((v) => !v)}
                >
                  <img
                    src={columnaddition}
                    style={{ height: "34px", width: "32px" }}
                    alt="column addition"
                  />
                  <span
                    style={{
                      marginLeft: "4px",
                      color: "#2F2E40",
                      marginRight: "14px",
                      fontSize: "14px",
                    }}
                  >
                    Column Selection
                  </span>
                  {isColumnDivVisible && (
                    <div ref={columnDropdownRef}>
                      <div className="arrow-up-tc"></div>
                      <div className="popupColumn-tc">
                        {headers
                          .filter((h) => h)
                          .map((column, index) => (
                            <div
                              key={index}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleColumnSelection(column);
                              }}
                            >
                              <input
                                type="checkbox"
                                id={`column-${index}`}
                                name="columnSelection"
                                value={column}
                                className="square-checkbox-tc"
                                checked={visibleColumns.includes(column)}
                                disabled={column === "Tip ID"}
                                readOnly
                              />
                              <label htmlFor={`column-${index}`}>{column}</label>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
 
              {/* Table */}
              {reportDashboardData.length > 0 ? (
                <div className="table-wrapper-cols-selections">
                  <table className="table-tc" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        {visibleColumns.map((heading, index) => (
                          <td
                            key={index}
                            className="Heading-tc"
                            style={{
                              textAlign: "right",
                              cursor: "pointer",
                              position: "relative",
                              width: `${100 / (visibleColumns.length + 1)}%`,
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                alignItems: "left",
                                justifyContent: "left",
                                color: "rgb(47, 46, 64)",
                                fontSize: "14px",
                              }}
                            >
                              {index === 0 && (
                                <span style={{ marginRight: "28px" }}></span>
                              )}
                              {heading}
                              <img
                                onClick={() => handleSort(heading)}
                                src={updown}
                                style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                                alt="sort"
                              />
                            </span>
                          </td>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData.map((row, rowIndex) => (
                        <tr key={rowIndex} className={rowIndex % 2 === 1 ? "even-row-tc" : ""}>
                          {visibleColumns.map((column, cellIndex) => (
                            <td
                              key={cellIndex}
                              style={{
                                width: `${100 / (visibleColumns.length + 1)}%`,
                                textAlign: "left",
                                color: "#6A6A6A",
                                verticalAlign: "middle",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {cellIndex === 0 ? (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <input
                                    type="checkbox"
                                    className="delete-question-checkbox-dqc"
                                    checked={selectedRows.includes(row[0])}
                                    onChange={() => handleRowSelect(rowIndex)}
                                  />
                                  <span
                                    className="truncated-text"
                                    title={row[headers.indexOf(column)]}
                                    style={{
                                      color: row[headers.indexOf(column)] ? "#337ab7" : "#999",
                                      cursor: row[headers.indexOf(column)] ? "pointer" : "default",
                                    }}
                                  >
                                    {row[headers.indexOf(column)] || ""}
                                  </span>
                                </div>
                              ) : (
                                <input
                                  type="text"
                                  value={row[headers.indexOf(column)]}
                                  onChange={(e) => {
                                    const updatedData = [...reportDashboardData];
                                    updatedData[(currentPage - 1) * pageSize + rowIndex][
                                      headers.indexOf(column)
                                    ] = e.target.value;
                                    setReportDashboardData(updatedData);
                                  }}
                                  style={{
                                    border: "none",
                                    outline: "none",
                                    background: "transparent",
                                    width: "100%",
                                    color: "#6A6A6A",
                                    fontSize: "14px",
                                  }}
                                />
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div
                  style={{ textAlign: "center", padding: "40px", color: "#6A6A6A", fontSize: "16px" }}
                >
                  No data available.
                </div>
              )}
 
              {/* Pagination */}
              <div
                className="pagination-tc"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                {reportDashboardData.length > 0 && (
                  <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
                    <button
                      onClick={() => setCurrentPage(1)}
                      disabled={currentPage === 1}
                      className="extreme-left-tc-pagination"
                    >
                      <img src={leftArrow} alt="" />
                    </button>
                    <button
                      onClick={() => setCurrentPage((p) => p - 1)}
                      disabled={currentPage === 1}
                      className="lefttc-pagination"
                    >
                      {"<"}
                    </button>
                    {renderPagination()}
                    <button
                      onClick={() => setCurrentPage((p) => p + 1)}
                      disabled={currentPage === totalPages}
                      className="righttc-pagination"
                    >
                      {">"}
                    </button>
                    <button
                      onClick={() => setCurrentPage(totalPages)}
                      disabled={currentPage === totalPages}
                      className="extreme-right-tc-pagination"
                    >
                      <img src={rightArrow} alt="" />
                    </button>
                  </div>
                )}
              </div>
 
              <div className="heading-selected-tips">
                <span>SELECTED TIPS</span>
              </div>
              <div className="create-ques-paper-ques-selected-container">
                <SelectedTipOfDayTable
                  selectedTips={selectedTips}
                  tipHeaders={headers}
                  setSelectedTips={setSelectedTips}
                  allTipsList={reportDashboardData}
                  setMessageBox={setMessageBox}
                  setIsMessageBoxVisible={setIsMessageBoxVisible}
                  setActiveImg={setActiveImg}
                  startDate={startDate}
                  endDate={endDate}
                  scheduledDates={scheduledDates}
                  setScheduledDates={setScheduledDates}
                  selectedFrequency={selectedFrequency}
                  currentDateTime={currentDateTime}  
                />
              </div>
 
              {/* Filter Sidebar */}
              {isFilterVisible && (
                <div className="filter-sidebar-tc">
                  <div className="filter-content-tc" style={{ position: "relative" }}>
                    <button
                      className="repman-cross-btn-HOD"
                      onClick={() => setIsFilterVisible(false)}
                    >
                      <p>X</p>
                    </button>
                    <h3 className="AdvanceF-heading-tc">Filter</h3>
                    <div className="filter-apply-reset-ques-rev-dash">
                      <button className="create-test-section-btn" onClick={handleApplyFilter}>
                        APPLY
                      </button>
                      {isFiltersApplied && (
                        <button className="create-test-section-btn" onClick={handleResetFilter}>
                          RESET
                        </button>
                      )}
                    </div>
                    <div className="filter-options-container">
                      {headers
                        .filter((_, index) => index !== 3 && index !== 4)
                        .map((header, filteredIndex) => {
                          const originalIndex = filteredIndex < 3 ? filteredIndex : filteredIndex + 2;
                          const uniqueOptions = [
                            ...new Set(
                              reportDashboardData
                                .map((row) => row[originalIndex])
                                .filter(Boolean)
                            ),
                          ].sort((a, b) =>
                            originalIndex === 0 || originalIndex === 6
                              ? a > b ? 1 : -1
                              : 0
                          );
 
                          return (
                            <SelectedValuesDropdown
                              key={originalIndex}
                              label={header}
                              width="300px"
                              marginLeft="15px"
                              marginTop="18px"
                              setSelected={(selectedOption) =>
                                setFilters((prev) => ({ ...prev, [header]: selectedOption }))
                              }
                              options={uniqueOptions.map((value) => ({ label: value, id: value }))}
                              selected={filters[header] || ""}
                              Height="auto"
                              OverFlow="auto"
                              minheight="200px"
                            />
                          );
                        })}
                    </div>
                  </div>
                </div>
              )}
 
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
 
export default ScheduleTipsOfDays;









// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputWithoutValidations";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Warning.png";
// import dummyData from "../TipInventoryDummyData.json";
// import "../tipinventory.css";
// import SelectedTipOfDayTable from "./SelectedTipOfDayTable";
// import { GET, POST } from "../../../Api/HttpsMethods";
// import EndPoints from "../../../Api/Endpoints";


// const ScheduleTipsOfDays = ({
//   dataClient,
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) => {
//   const navigate = useNavigate();
//   const columnDropdownRef = useRef(null);
//   const [selectedScheduleType, setSelectedScheduleType] = useState(null);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [scheduleLaunchTime, setScheduleLaunchTime] = useState("");
//   const [selectedFrequency, setSelectedFrequency] = useState(null);
//   const [isScheduleOpen, setIsScheduleOpen] = useState(true);
//   const [isFilterTipOpen, setIsFilterTipOpen] = useState(true);
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const [filters, setFilters] = useState({});
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   const [scheduledDates, setScheduledDates] = useState({});
//   const bulk = true;
//   const searchPlaceholder = "Filter Tip Requests...";
//   const [selectedTips, setSelectedTips] = useState([]);
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;

//   useEffect(() => {
//   const fetchTipOfDayList = async () => {
//     try {
//       const url = EndPoints.GET_ALL_TIP_OF_DAY; // or whatever the endpoint name is
//       const response = await GET.withToken(url, {
//         setMessageBox,
//         setIsMessageBoxVisible,
//         setActiveImg,
//         ErrorImg,
//       });

//       if (response && response.status === 200 && response.headers) {
//         // Parse the API response structure
//         const allItems = response.headers;
        
//         // Find where headers end and data rows begin
//         const firstRowIndex = allItems.findIndex(item => Array.isArray(item));
        
//         // Extract and clean headers (remove prefixes like "n*", "t*", "d*")
//         const rawHeaders = allItems.slice(0, firstRowIndex);
//         const cleanHeaders = rawHeaders.map(header => 
//           header.replace(/^[ntd]\*/, '').trim()
//         );
        
//         // Extract data rows
//         const rows = allItems.slice(firstRowIndex);
        
//         // Transform rows for date formatting
//         const transformedRows = rows.map((row) =>
//           row.map((cell, index) => {
//             // Check if this column is a date (based on raw header prefix)
//             const rawHeader = rawHeaders[index];
//             if (rawHeader && rawHeader.startsWith('d*')) {
//               if (!cell) return "";
//               try {
//                 return new Date(cell).toLocaleDateString("en-US", {
//                   year: "numeric",
//                   month: "short",
//                   day: "2-digit",
//                   hour: "2-digit",
//                   minute: "2-digit",
//                 });
//               } catch {
//                 return cell;
//               }
//             }
//             return cell === "" || cell === null || cell === undefined ? "" : cell;
//           })
//         );

//         setHeaders(cleanHeaders);
//         setReportDashboardData(transformedRows);
//       }
//     } catch (error) {
//       console.error("Error fetching tip of day list:", error);
//     }
//   };

//   fetchTipOfDayList();
// }, []);

//   useEffect(() => {
//     setVisibleColumns(headers.slice(0, 5));
//   }, [headers]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   useEffect(() => {
//     const selectedTipIds = selectedTips.map(row => row[0]);
//     setSelectedRows(selectedTipIds);
//   }, [selectedTips]);

//   const handleColumnSelection = (column) => {
//     setVisibleColumns((prev) =>
//       prev.includes(column) ? prev.filter((c) => c !== column) : [...prev, column]
//     );
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters });
//       setCurrentPage(1);
//       setIsFiltersApplied(true);
//       setIsFilterVisible(false);
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({});
//     setAppliedFilters({});
//     setAverageRunTime("");
//     setIsFiltersApplied(false);
//   };

//   const handleSort = (column) => {
//     setSortConfig((prev) => ({
//       key: column,
//       direction: prev.key === column && prev.direction === "asc" ? "desc" : "asc",
//     }));
//   };

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handleSelectAll = (e) => {
//     if (!bulk) return;
//     setSelectedRows(e.target.checked ? reportDashboardData.map((row) => row[0]) : []);
//   };

//   const handleRowSelect = (rowIndex) => {
//     const actualIndex = (currentPage - 1) * pageSize + rowIndex;
//     const row = reportDashboardData[actualIndex];
//     const tipId = row[0];

//     if (bulk) {
//       setSelectedRows((prev) =>
//         prev.includes(tipId) ? prev.filter((id) => id !== tipId) : [...prev, tipId]
//       );
//     } else {
//       setSelectedRows([tipId]);
//     }

//     setSelectedTips((prev) => {
//       const exists = prev.find((r) => r[0] === tipId);
//       return exists ? prev.filter((r) => r[0] !== tipId) : [...prev, row];
//     });
//   };

//   const filteredData = reportDashboardData.filter((row) => {
//     const matchesSearch =
//       searchQuery === "" ||
//       row.some((cell) => cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase()));
//     const matchesAvgRT = averageRunTime === "" || row[2] === averageRunTime;
//     const matchesFilters = Object.entries(appliedFilters).every(([key, value]) => {
//       const colIndex = headers.indexOf(key);
//       return value ? row[colIndex] === value : true;
//     });
//     return matchesSearch && matchesAvgRT && matchesFilters;
//   });

//   const sortedData = React.useMemo(() => {
//     if (sortConfig.key === null) return filteredData;
//     const colIndex = headers.indexOf(sortConfig.key);
//     return [...filteredData].sort((a, b) => {
//       if (a[colIndex] < b[colIndex]) return sortConfig.direction === "asc" ? -1 : 1;
//       if (a[colIndex] > b[colIndex]) return sortConfig.direction === "asc" ? 1 : -1;
//       return 0;
//     });
//   }, [filteredData, sortConfig, headers]);

//   const totalPages = Math.ceil(sortedData.length / pageSize);

//   const paginatedData = React.useMemo(() => {
//     const start = (currentPage - 1) * pageSize;
//     return sortedData.slice(start, start + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     const btn = (i) => (
//       <button
//         key={i}
//         onClick={() => setCurrentPage(i)}
//         style={{ borderRadius: "5px" }}
//         className={i === currentPage ? "active" : ""}
//       >
//         {i}
//       </button>
//     );
//     const dots = (k) => (
//       <span key={k} style={{ borderRadius: "5px" }}>
//         ...
//       </span>
//     );

//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) pages.push(btn(i));
//     } else if (currentPage <= 3) {
//       [1, 2, 3].forEach((i) => pages.push(btn(i)));
//       pages.push(dots("d1"));
//       pages.push(btn(totalPages));
//     } else if (currentPage > 3 && currentPage < totalPages - 2) {
//       pages.push(btn(1));
//       pages.push(dots("d1"));
//       for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(btn(i));
//       pages.push(dots("d2"));
//       pages.push(btn(totalPages));
//     } else {
//       pages.push(btn(1));
//       pages.push(dots("d1"));
//       for (let i = totalPages - 2; i <= totalPages; i++) pages.push(btn(i));
//     }
//     return pages;
//   };

//   // ── Extracted save logic ──────────────────────────────────────────────────
//   const proceedToSave = async () => {
//     try {
//       const scheduleData = selectedTips.map((row) => ({
//         scheduled_date: scheduledDates[row[0]],
//         tip_id: row[0],
//       }));

//       const payload = {
//         user_name: userName,
//         schedule_data: scheduleData,
//       };

//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Saving schedule...</span>
//           </div>
//         </div>
//       );

//       const url = EndPoints.CREATE_TIP_OF_THE_DAY_SCHEDULE;
//       const response = await POST.withToken(url, payload, {
//         setMessageBox,
//         setIsMessageBoxVisible,
//         setActiveImg,
//         ErrorImg,
//       });

//       if (response && response.status === 200) {
//         setIsMessageBoxVisible(true);
//         setActiveImg(ErrorImg);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Tip of the Day schedule has been saved successfully!</span>
//             </div>
//           </div>
//         );
//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//           navigate("/tip_dashboard");
//         }, 2000);
//       } else {
//         throw new Error(response?.message || "Failed to save schedule");
//       }
//     } catch (error) {
//       console.error("Error saving schedule:", error);
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Failed to save schedule. Please try again. {error.message}</span>
//           </div>
//         </div>
//       );
//     }
//   };

//   // ── Main save handler with validations ───────────────────────────────────
//   const handleSave = async () => {
//     if (!startDate || !endDate) {
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Please select a From Date and To Date before saving.</span>
//           </div>
//         </div>
//       );
//       return;
//     }

//     if (new Date(endDate) < new Date(startDate)) {
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>To Date cannot be earlier than From Date.</span>
//           </div>
//         </div>
//       );
//       return;
//     }

//     if (!selectedFrequency) {
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Please select a Frequency before saving.</span>
//           </div>
//         </div>
//       );
//       return;
//     }

//     if (selectedTips.length === 0) {
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Please select at least one tip before saving.</span>
//           </div>
//         </div>
//       );
//       return;
//     }

//     const frequencyGapDays = {
//       once_in_1_day: 1,
//       once_in_2_days: 2,
//       once_in_3_days: 3,
//       once_in_4_days: 4,
//       once_in_5_days: 5,
//       once_in_6_days: 6,
//       once_in_week: 7,
//     };
//     const gapDays = frequencyGapDays[selectedFrequency.id] ?? 1;

//     const unscheduledTips = selectedTips.filter((row) => !scheduledDates[row[0]]);
//     if (unscheduledTips.length > 0) {
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               {unscheduledTips.length} tip(s) do not have a scheduled date assigned.
//               Please assign a date to every selected tip.
//             </span>
//           </div>
//         </div>
//       );
//       return;
//     }

//     const dateCounts = {};
//     selectedTips.forEach((row) => {
//       const date = scheduledDates[row[0]];
//       if (date) dateCounts[date] = (dateCounts[date] || 0) + 1;
//     });
//     const conflictDates = Object.entries(dateCounts)
//       .filter(([, count]) => count > 1)
//       .map(([date]) =>
//         new Date(date).toLocaleDateString("en-US", {
//           month: "short",
//           day: "2-digit",
//           year: "numeric",
//         })
//       );
//     if (conflictDates.length > 0) {
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               Multiple tips on same date: {conflictDates.join(", ")}. Please select
//               different dates for each tip.
//             </span>
//           </div>
//         </div>
//       );
//       return;
//     }

//     // ── Gap check — warn but allow save ──────────────────────────────────────
//     const scheduledDatesList = selectedTips
//       .map((row) => scheduledDates[row[0]])
//       .filter(Boolean)
//       .map((d) => new Date(d))
//       .sort((a, b) => a - b);

//     if (scheduledDatesList.length > 1) {
//       const minDate = scheduledDatesList[0];
//       const maxDate = scheduledDatesList[scheduledDatesList.length - 1];

//       const allDatesInRange = [];
//       for (let d = new Date(minDate); d <= maxDate; d.setDate(d.getDate() + 1)) {
//         allDatesInRange.push(new Date(d).toISOString().split("T")[0]);
//       }

//       const scheduledDateStrings = scheduledDatesList.map((d) =>
//         d.toISOString().split("T")[0]
//       );
//       const missingDates = allDatesInRange.filter(
//         (date) => !scheduledDateStrings.includes(date)
//       );

//     if (missingDates.length > 0) {
//         const formattedMissing = missingDates.map((date) =>
//           new Date(date).toLocaleDateString("en-US", {
//             month: "short",
//             day: "2-digit",
//             year: "numeric",
//           })
//         );

//         const rangeStart = minDate.toLocaleDateString("en-US", {
//           month: "short",
//           day: "2-digit",
//           year: "numeric",
//         });
//         const rangeEnd = maxDate.toLocaleDateString("en-US", {
//           month: "short",
//           day: "2-digit",
//           year: "numeric",
//         });

//         setIsMessageBoxVisible(true);
//         setActiveImg(ErrorImg);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 You have selected date range from <strong>{rangeStart}</strong> to{" "}
//                 <strong>{rangeEnd}</strong> but no tip is selected for:{" "}
//                 <strong>{formattedMissing.join(", ")}</strong>. Save anyway?
//               </span>
//             </div>
//             <div
//               className="messagebox-insider2"
//               style={{ display: "flex", gap: "10px", marginTop: "10px" }}
//             >
//               <button
//                 className="messagebox-cancel-btn-ok"
//                 onClick={async () => {
//                   setIsMessageBoxVisible(false);
//                   await proceedToSave();
//                 }}
//               >
//                 OK
//               </button>
//               <button
//                 className="messagebox-cancel-btn-ok"
//                 style={{width: "80px"}}
//                 onClick={() => setIsMessageBoxVisible(false)}
//               >
//                 CANCEL
//               </button>
//             </div>
//           </div>
//         );
//         return;
//       }
//     }

//     if (gapDays > 1) {
//       const sortedDates = selectedTips
//         .map((row) => scheduledDates[row[0]])
//         .filter(Boolean)
//         .map((d) => new Date(d))
//         .sort((a, b) => a - b);

//       for (let i = 1; i < sortedDates.length; i++) {
//         const diffDays = Math.round(
//           (sortedDates[i] - sortedDates[i - 1]) / (1000 * 60 * 60 * 24)
//         );
//         if (diffDays < gapDays) {
//           setIsMessageBoxVisible(true);
//           setActiveImg(ErrorImg);
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>
//                   With &quot;{selectedFrequency.label}&quot;, tips must be at least{" "}
//                   {gapDays} day(s) apart. Some tips are scheduled too close together.
//                 </span>
//               </div>
//             </div>
//           );
//           return;
//         }
//       }
//     }

//     await proceedToSave();
//   };

//   return (
//     <div className="create-role-container">
//       {/* Top Header */}
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Tip of the Day - Schedule</span>
//         <div className="create-test-section-btns-container-ques-paper-dels">
//           <button
//             className="create-test-section-btn-ques-paper-del"
//             onClick={() => navigate(-1)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="create-test-section-btn-ques-paper-del"
//             style={{ marginRight: "0px", boxShadow: "0px 4px 4px 0px #00000040" }}
//              onClick={handleSave}
//             onMouseEnter={(e) => {
//               e.target.style.backgroundColor = "#fa4741";
//               e.target.style.color = "white";
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.backgroundColor = "white";
//               e.target.style.color = "#424342";
//             }}
//           >
//             SAVE
//           </button>
//         </div>
//       </div>

//       {/* SCHEDULE ENGINE Accordion */}
//       <div className="display-ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>DATE RANGE & FREQUENCY</label>
//           </div>
//           <div className="accordion-btn" onClick={() => setIsScheduleOpen((o) => !o)}>
//             {isScheduleOpen ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isScheduleOpen && (
//           <div className="accordion-content">
//             <div className="display-test-data-container-ques-paper-del-filter-tags">
//               <div className="display-grid-container-ques-paper-del-filter-tags">
//                 <div className="item2">
//                   <FormInputs
//                     label="From Date"
//                     type="date"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                     placeholder="mm/dd/yyyy"
//                     min={new Date().toISOString().split("T")[0]}
//                   />
//                 </div>
//                 <div className="item3">
//                   <FormInputs
//                     label="To Date"
//                     type="date"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                     placeholder="mm/dd/yyyy"
//                     min={new Date().toISOString().split("T")[0]}
//                   />
//                 </div>
//                 <div className="item5">
//                   <DropDown
//                     label="Frequency"
//                     selected={selectedFrequency}
//                     setSelected={(opt) => setSelectedFrequency(opt || null)}
//                     options={[
//                       { label: "Once in a Day", id: "1" },
//                       { label: "Once in Two Days", id: "2" },
//                       { label: "Once in Three Days", id: "3" },
//                       { label: "Once in Four Days", id: "4" },
//                       { label: "Once in Five Days", id: "5" },
//                       { label: "Once in Six Days", id: "6" },
//                       { label: "Once in a Week", id: "7" },
//                     ]}
//                     isRequired={true}
//                     placeholder="Choose Frequency..."
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* FILTER TIP Accordion */}
//       <div className="display-ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>Tip Management</label>
//           </div>      
//         </div>
//         {isFilterTipOpen && (
//           <div className="accordion-content">
//               <div className="heading-table-list-tips">
//                 <span>TIPS LIST</span>
//               </div>
//             <div className="selected-tips-content-wrapper">
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   width: "81vw",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     border: "1px solid #6A6A6A",
//                     overflow: "hidden",
//                   }}
//                 >
//                   <input
//                     type="text"
//                     placeholder={searchPlaceholder}
//                     name="search"
//                     className="search-input-ques-dash"
//                     onChange={handleSearch}
//                   />
//                   <div
//                     style={{
//                       width: "1px",
//                       height: "24px",
//                       backgroundColor: "#2F2E40",
//                       margin: "0 4px",
//                     }}
//                   />
//                   <img src={searchicon} alt="search" className="search-icon-ques-dash" />
//                 </div>
//                 <div style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}>
//                   Displaying{" "}
//                   {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//                   {Math.min(currentPage * pageSize, sortedData.length)} of {sortedData.length}{" "}
//                   records |{" "}
//                   {["10", "25", "50", "100", "500"].map((size) => (
//                     <span
//                       key={size}
//                       onClick={() => handlePageSizeChange(Number(size))}
//                       style={{
//                         cursor: "pointer",
//                         margin: "0 5px",
//                         textDecoration: size === pageSize.toString() ? "none" : "underline",
//                         color: size === pageSize.toString() ? "black" : "#337AB7",
//                       }}
//                     >
//                       {size}
//                     </span>
//                   ))}
//                 </div>
//               </div>

//               {/* Action Bar */}
//               <div
//                 style={{
//                   display: "flex",
//                   backgroundColor: "#D6D6D6",
//                   marginTop: "9px",
//                   borderTop: "1px solid grey",
//                   borderBottom: "1px solid grey",
//                 }}
//               >
//                 <div
//                   style={{
//                     backgroundColor: "#FFBD20",
//                     display: "flex",
//                     alignItems: "center",
//                     cursor: "pointer",
//                     paddingLeft: "8px",
//                     width: "90px",
//                   }}
//                   onClick={() => setIsFilterVisible((v) => !v)}
//                 >
//                   <img src={Filter} style={{ height: "24px", width: "24px" }} alt="filter" />
//                   <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//                 </div>

//                 {/* Column Selection */}
//                 <div
//                   className="col-tc"
//                   style={{
//                     marginLeft: "auto",
//                     textAlign: "end",
//                     marginRight: "8px",
//                     display: "flex",
//                     alignItems: "center",
//                     position: "relative",
//                     cursor: "pointer",
//                     height: "40px",
//                   }}
//                   onClick={() => setIsColumnDivVisible((v) => !v)}
//                 >
//                   <img
//                     src={columnaddition}
//                     style={{ height: "34px", width: "32px" }}
//                     alt="column addition"
//                   />
//                   <span
//                     style={{
//                       marginLeft: "4px",
//                       color: "#2F2E40",
//                       marginRight: "14px",
//                       fontSize: "14px",
//                     }}
//                   >
//                     Column Selection
//                   </span>
//                   {isColumnDivVisible && (
//                     <div ref={columnDropdownRef}>
//                       <div className="arrow-up-tc"></div>
//                       <div className="popupColumn-tc">
//                         {headers
//                           .filter((h) => h)
//                           .map((column, index) => (
//                             <div
//                               key={index}
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleColumnSelection(column);
//                               }}
//                             >
//                               <input
//                                 type="checkbox"
//                                 id={`column-${index}`}
//                                 name="columnSelection"
//                                 value={column}
//                                 className="square-checkbox-tc"
//                                 checked={visibleColumns.includes(column)}
//                                 disabled={column === "Tip ID"}
//                                 readOnly
//                               />
//                               <label htmlFor={`column-${index}`}>{column}</label>
//                             </div>
//                           ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Table */}
//               {reportDashboardData.length > 0 ? (
//                 <div className="table-wrapper-cols-selections">
//                   <table className="table-tc" style={{ width: "100%" }}>
//                     <thead>
//                       <tr>
//                         {visibleColumns.map((heading, index) => (
//                           <td
//                             key={index}
//                             className="Heading-tc"
//                             style={{
//                               textAlign: "right",
//                               cursor: "pointer",
//                               position: "relative",
//                               width: `${100 / (visibleColumns.length + 1)}%`,
//                             }}
//                           >
//                             <span
//                               style={{
//                                 display: "flex",
//                                 alignItems: "left",
//                                 justifyContent: "left",
//                                 color: "rgb(47, 46, 64)",
//                                 fontSize: "14px",
//                               }}
//                             >
//                               {index === 0 && (
//                                 <span style={{ marginRight: "28px" }}></span>
//                               )}
//                               {heading}
//                               <img
//                                 onClick={() => handleSort(heading)}
//                                 src={updown}
//                                 style={{ height: "20px", width: "20px", marginLeft: "5px" }}
//                                 alt="sort"
//                               />
//                             </span>
//                           </td>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {paginatedData.map((row, rowIndex) => (
//                         <tr key={rowIndex} className={rowIndex % 2 === 1 ? "even-row-tc" : ""}>
//                           {visibleColumns.map((column, cellIndex) => (
//                             <td
//                               key={cellIndex}
//                               style={{
//                                 width: `${100 / (visibleColumns.length + 1)}%`,
//                                 textAlign: "left",
//                                 color: "#6A6A6A",
//                                 verticalAlign: "middle",
//                                 whiteSpace: "nowrap",
//                                 overflow: "hidden",
//                                 textOverflow: "ellipsis",
//                               }}
//                             >
//                               {cellIndex === 0 ? (
//                                 <div style={{ display: "flex", alignItems: "center" }}>
//                                   <input
//                                     type="checkbox"
//                                     className="delete-question-checkbox-dqc"
//                                     checked={selectedRows.includes(row[0])}
//                                     onChange={() => handleRowSelect(rowIndex)}
//                                   />
//                                   <span
//                                     className="truncated-text"
//                                     title={row[headers.indexOf(column)]}
//                                     style={{
//                                       color: row[headers.indexOf(column)] ? "#337ab7" : "#999",
//                                       cursor: row[headers.indexOf(column)] ? "pointer" : "default",
//                                     }}
//                                   >
//                                     {row[headers.indexOf(column)] || ""}
//                                   </span>
//                                 </div>
//                               ) : (
//                                 <input
//                                   type="text"
//                                   value={row[headers.indexOf(column)]}
//                                   onChange={(e) => {
//                                     const updatedData = [...reportDashboardData];
//                                     updatedData[(currentPage - 1) * pageSize + rowIndex][
//                                       headers.indexOf(column)
//                                     ] = e.target.value;
//                                     setReportDashboardData(updatedData);
//                                   }}
//                                   style={{
//                                     border: "none",
//                                     outline: "none",
//                                     background: "transparent",
//                                     width: "100%",
//                                     color: "#6A6A6A",
//                                     fontSize: "14px",
//                                   }}
//                                 />
//                               )}
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               ) : (
//                 <div
//                   style={{ textAlign: "center", padding: "40px", color: "#6A6A6A", fontSize: "16px" }}
//                 >
//                   No data available.
//                 </div>
//               )}

//               {/* Pagination */}
//               <div
//                 className="pagination-tc"
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   position: "relative",
//                 }}
//               >
//                 {reportDashboardData.length > 0 && (
//                   <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
//                     <button
//                       onClick={() => setCurrentPage(1)}
//                       disabled={currentPage === 1}
//                       className="extreme-left-tc-pagination"
//                     >
//                       <img src={leftArrow} alt="" />
//                     </button>
//                     <button
//                       onClick={() => setCurrentPage((p) => p - 1)}
//                       disabled={currentPage === 1}
//                       className="lefttc-pagination"
//                     >
//                       {"<"}
//                     </button>
//                     {renderPagination()}
//                     <button
//                       onClick={() => setCurrentPage((p) => p + 1)}
//                       disabled={currentPage === totalPages}
//                       className="righttc-pagination"
//                     >
//                       {">"}
//                     </button>
//                     <button
//                       onClick={() => setCurrentPage(totalPages)}
//                       disabled={currentPage === totalPages}
//                       className="extreme-right-tc-pagination"
//                     >
//                       <img src={rightArrow} alt="" />
//                     </button>
//                   </div>
//                 )}
//               </div>
//               <div className="heading-selected-tips">
//                 <span>SELECTED TIPS</span>
//               </div>
//               <div className="create-ques-paper-ques-selected-container">
//                 <SelectedTipOfDayTable
//                   selectedTips={selectedTips}
//                   tipHeaders={headers}
//                   setSelectedTips={setSelectedTips}
//                   allTipsList={reportDashboardData}
//                   setMessageBox={setMessageBox}
//                   setIsMessageBoxVisible={setIsMessageBoxVisible}
//                   setActiveImg={setActiveImg}
//                   startDate={startDate}
//                   endDate={endDate}
//                   scheduledDates={scheduledDates}       
//                   setScheduledDates={setScheduledDates} 
//                   selectedFrequency={selectedFrequency}
//                 />
//               </div>

//               {/* Filter Sidebar */}
//               {isFilterVisible && (
//                 <div className="filter-sidebar-tc">
//                   <div className="filter-content-tc" style={{ position: "relative" }}>
//                     <button
//                       className="repman-cross-btn-HOD"
//                       onClick={() => setIsFilterVisible(false)}
//                     >
//                       <p>X</p>
//                     </button>
//                     <h3 className="AdvanceF-heading-tc">Filter</h3>
//                     <div className="filter-apply-reset-ques-rev-dash">
//                       <button className="create-test-section-btn" onClick={handleApplyFilter}>
//                         APPLY
//                       </button>
//                       {isFiltersApplied && (
//                         <button className="create-test-section-btn" onClick={handleResetFilter}>
//                           RESET
//                         </button>
//                       )}
//                     </div>
//                     <div className="filter-options-container">
//                       {headers
//                         .filter((_, index) => index !== 3 && index !== 4)
//                         .map((header, filteredIndex) => {
//                           const originalIndex = filteredIndex < 3 ? filteredIndex : filteredIndex + 2;
//                           const uniqueOptions = [
//                             ...new Set(
//                               reportDashboardData
//                                 .map((row) => row[originalIndex])
//                                 .filter(Boolean)
//                             ),
//                           ].sort((a, b) =>
//                             originalIndex === 0 || originalIndex === 6
//                               ? a > b
//                                 ? 1
//                                 : -1
//                               : 0
//                           );

//                           return (
//                             <SelectedValuesDropdown
//                               key={originalIndex}
//                               label={header}
//                               width="300px"
//                               marginLeft="15px"
//                               marginTop="18px"
//                               setSelected={(selectedOption) =>
//                                 setFilters((prev) => ({ ...prev, [header]: selectedOption }))
//                               }
//                               options={uniqueOptions.map((value) => ({ label: value, id: value }))}
//                               selected={filters[header] || ""}
//                               Height="auto"
//                               OverFlow="auto"
//                               minheight="200px"
//                             />
//                           );
//                         })}
//                     </div>
//                   </div>
//                 </div>
//               )}

//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ScheduleTipsOfDays;































// handle save function with validations and API call to save schedule
  // const handleSave = async () => {
  //   // ── 1. Basic field validation ──────────────────────────────────────────────
  //   if (!startDate || !endDate) {
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorImg);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>Please select a From Date and To Date before saving.</span>
  //         </div>
  //       </div>
  //     );
  //     return;
  //   }

  //   if (new Date(endDate) < new Date(startDate)) {
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorImg);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>To Date cannot be earlier than From Date.</span>
  //         </div>
  //       </div>
  //     );
  //     return;
  //   }

  //   if (!selectedFrequency) {
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorImg);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>Please select a Frequency before saving.</span>
  //         </div>
  //       </div>
  //     );
  //     return;
  //   }

  //   if (selectedTips.length === 0) {
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorImg);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>Please select at least one tip before saving.</span>
  //         </div>
  //       </div>
  //     );
  //     return;
  //   }

  //   // ── 2. Frequency gap rules ─────────────────────────────────────────────────
  //   const frequencyGapDays = {
  //     once_in_1_day: 1,
  //     once_in_2_days: 2,
  //     once_in_3_days: 3,
  //     once_in_4_days: 4,
  //     once_in_5_days: 5,
  //     once_in_6_days: 6,
  //     once_in_week: 7,
  //   };

  //   const gapDays = frequencyGapDays[selectedFrequency.id] ?? 1;

  //   // ── 3. Check every tip has a scheduled date assigned ──────────────────────
  //   const unscheduledTips = selectedTips.filter((row) => !scheduledDates[row[0]]);
  //   if (unscheduledTips.length > 0) {
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorImg);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>
  //             {unscheduledTips.length} tip(s) do not have a scheduled date
  //             assigned. Please assign a date to every selected tip.
  //           </span>
  //         </div>
  //       </div>
  //     );
  //     return;
  //   }

  //   // ── 4. Check for duplicate dates ───────────────────────────────────────────
  //   const dateCounts = {};
  //   selectedTips.forEach((row) => {
  //     const date = scheduledDates[row[0]];
  //     if (date) dateCounts[date] = (dateCounts[date] || 0) + 1;
  //   });

  //   const conflictDates = Object.entries(dateCounts)
  //     .filter(([, count]) => count > 1)
  //     .map(([date]) =>
  //       new Date(date).toLocaleDateString("en-US", {
  //         month: "short",
  //         day: "2-digit",
  //         year: "numeric",
  //       })
  //     );

  //   if (conflictDates.length > 0) {
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorImg);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>
  //             You cannot schedule multiple tips on the same date. The following 
  //             date(s) have more than one tip assigned: {conflictDates.join(", ")}. 
  //             Please select different dates for each tip.
  //           </span>
  //         </div>
  //       </div>
  //     );
  //     return;
  //   }

  //   // ── 4.5. Check for gaps in scheduled date range ───────────────────────────
  //   const scheduledDatesList = selectedTips
  //     .map((row) => scheduledDates[row[0]])
  //     .filter(Boolean)
  //     .map((d) => new Date(d))
  //     .sort((a, b) => a - b);

  //   if (scheduledDatesList.length > 1) {
  //     const minDate = scheduledDatesList[0];
  //     const maxDate = scheduledDatesList[scheduledDatesList.length - 1];
      
  //     const allDatesInRange = [];
  //     for (let d = new Date(minDate); d <= maxDate; d.setDate(d.getDate() + 1)) {
  //       allDatesInRange.push(new Date(d).toISOString().split("T")[0]);
  //     }
      
  //     const scheduledDateStrings = scheduledDatesList.map(d => 
  //       d.toISOString().split("T")[0]
  //     );
  //     const missingDates = allDatesInRange.filter(
  //       date => !scheduledDateStrings.includes(date)
  //     );
      
  //     if (missingDates.length > 0) {
  //       const formattedMissing = missingDates.map(date =>
  //         new Date(date).toLocaleDateString("en-US", {
  //           month: "short",
  //           day: "2-digit",
  //           year: "numeric",
  //         })
  //       );
        
  //       const rangeStart = minDate.toLocaleDateString("en-US", {
  //         month: "short",
  //         day: "2-digit",
  //         year: "numeric",
  //       });
  //       const rangeEnd = maxDate.toLocaleDateString("en-US", {
  //         month: "short",
  //         day: "2-digit",
  //         year: "numeric",
  //       });
        
  //       setIsMessageBoxVisible(true);
  //       setActiveImg(ErrorImg);
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>
  //               You have selected date range from {rangeStart} to {rangeEnd} but no 
  //               tip is selected for: {formattedMissing.join(", ")}. Please assign tips 
  //               for all dates or remove tips to close the gap.
  //             </span>
  //           </div>
  //              <div className="messagebox-insider2" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
  //           <button
  //             className="messagebox-cancel-btn-ok"
  //             onClick={() => {
  //               setIsMessageBoxVisible(false);
  //             }}
  //           >
  //             OK
  //           </button>
  //         </div>
  //         </div>
  //       );
  //       return;
  //     }
  //   }

  //   // ── 5. Check minimum gap between consecutive scheduled dates ───────────────
  //   if (gapDays > 1) {
  //     const sortedDates = selectedTips
  //       .map((row) => scheduledDates[row[0]])
  //       .filter(Boolean)
  //       .map((d) => new Date(d))
  //       .sort((a, b) => a - b);

  //     for (let i = 1; i < sortedDates.length; i++) {
  //       const diffDays = Math.round(
  //         (sortedDates[i] - sortedDates[i - 1]) / (1000 * 60 * 60 * 24)
  //       );
  //       if (diffDays < gapDays) {
  //         setIsMessageBoxVisible(true);
  //         setActiveImg(ErrorImg);
  //         setMessageBox(
  //           <div className="Container-messageBOX">
  //             <div className="messagebox-insider1">
  //               <div className="loader-tc"></div>
  //               <span>
  //                 With &quot;{selectedFrequency.label}&quot;, tips must be at
  //                 least {gapDays} day(s) apart. Some tips are scheduled too close
  //                 together.
  //               </span>
  //             </div>
  //           </div>
  //         );
  //         return;
  //       }
  //     }
  //   }

  //   // ══════════════════════════════════════════════════════════════════════════
  //   // ── 6. All validations passed - Make API call to save schedule ────────────
  //   // ══════════════════════════════════════════════════════════════════════════
  //   try {
  //     // Prepare the schedule data
  //     const scheduleData = selectedTips.map((row) => ({
  //       scheduled_date: scheduledDates[row[0]], // Format: "YYYY-MM-DD"
  //       tip_id: row[0], // Tip ID
  //     }));

  //     // Prepare the request payload
  //     const payload = {
  //       user_name: userName,
  //       schedule_data: scheduleData,
  //     };

  //     // Show loading message
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorImg);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>Saving schedule...</span>
  //         </div>
  //       </div>
  //     );

  //     // Make the API call
  //     const url = EndPoints.CREATE_TIP_OF_THE_DAY_SCHEDULE;
  //     const response = await POST.withToken(url, payload, {
  //       setMessageBox,
  //       setIsMessageBoxVisible,
  //       setActiveImg,
  //       ErrorImg,
  //     });

  //     if (response && response.status === 200) {
  //       // Success
  //       setIsMessageBoxVisible(true);
  //       setActiveImg(ErrorImg);
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>
  //               Tip of the Day schedule has been saved successfully!
  //             </span>
  //           </div>
  //         </div>
  //       );
  //       setTimeout(() => {
  //         setIsMessageBoxVisible(false);
  //         navigate("/tip_dashboard");
  //       }, 2000);
  //     } else {
  //       throw new Error(response?.message || "Failed to save schedule");
  //     }
  //   } catch (error) {
  //     console.error("Error saving schedule:", error);
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorImg);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>
  //             Failed to save schedule. Please try again. {error.message}
  //           </span>
  //         </div>
  //       </div>
  //     );
  //   }
  // };











//   const handleSave = () => {
//   // ── 1. Basic field validation ──────────────────────────────────────────────
//   if (!startDate || !endDate) {
//     setIsMessageBoxVisible(true);
//     setActiveImg(ErrorImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Please select a From Date and To Date before saving.</span>
//         </div>
//       </div>
//     );
//     return;
//   }

//   if (new Date(endDate) < new Date(startDate)) {
//     setIsMessageBoxVisible(true);
//     setActiveImg(ErrorImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>To Date cannot be earlier than From Date.</span>
//         </div>
//       </div>
//     );
//     return;
//   }

//   if (!selectedFrequency) {
//     setIsMessageBoxVisible(true);
//     setActiveImg(ErrorImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Please select a Frequency before saving.</span>
//         </div>
//       </div>
//     );
//     return;
//   }

//   if (selectedTips.length === 0) {
//     setIsMessageBoxVisible(true);
//     setActiveImg(ErrorImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Please select at least one tip before saving.</span>
//         </div>
//       </div>
//     );
//     return;
//   }

//   // ── 2. Frequency gap rules ─────────────────────────────────────────────────
//   const frequencyGapDays = {
//     once_in_1_day: 1,
//     once_in_2_days: 2,
//     once_in_3_days: 3,
//     once_in_4_days: 4,
//     once_in_5_days: 5,
//     once_in_6_days: 6,
//     once_in_week: 7,
//   };

//   const gapDays = frequencyGapDays[selectedFrequency.id] ?? 1;

//   // ── 3. Check every tip has a scheduled date assigned ──────────────────────
//   const unscheduledTips = selectedTips.filter((row) => !scheduledDates[row[0]]);
//   if (unscheduledTips.length > 0) {
//     setIsMessageBoxVisible(true);
//     setActiveImg(ErrorImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>
//             {unscheduledTips.length} tip(s) do not have a scheduled date
//             assigned. Please assign a date to every selected tip.
//           </span>
//         </div>
//       </div>
//     );
//     return;
//   }

//   // ── 4. Check for duplicate dates (all frequencies: one tip per date) ───────
//   const dateCounts = {};
//   selectedTips.forEach((row) => {
//     const date = scheduledDates[row[0]];
//     if (date) dateCounts[date] = (dateCounts[date] || 0) + 1;
//   });

//   const conflictDates = Object.entries(dateCounts)
//     .filter(([, count]) => count > 1)
//     .map(([date]) =>
//       new Date(date).toLocaleDateString("en-US", {
//         month: "short",
//         day: "2-digit",
//         year: "numeric",
//       })
//     );

//   if (conflictDates.length > 0) {
//     setIsMessageBoxVisible(true);
//     setActiveImg(ErrorImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>
//             With &quot;{selectedFrequency.label}&quot;, only one tip can be
//             scheduled per date. Conflicting date(s): {conflictDates.join(", ")}.
//           </span>
//         </div>
//       </div>
//     );
//     return;
//   }

//   // ── 5. Check minimum gap between consecutive scheduled dates ───────────────
//   if (gapDays > 1) {
//     const sortedDates = selectedTips
//       .map((row) => scheduledDates[row[0]])
//       .filter(Boolean)
//       .map((d) => new Date(d))
//       .sort((a, b) => a - b);

//     for (let i = 1; i < sortedDates.length; i++) {
//       const diffDays = Math.round(
//         (sortedDates[i] - sortedDates[i - 1]) / (1000 * 60 * 60 * 24)
//       );
//       if (diffDays < gapDays) {
//         setIsMessageBoxVisible(true);
//         setActiveImg(ErrorImg);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 With &quot;{selectedFrequency.label}&quot;, tips must be at
//                 least {gapDays} day(s) apart. Some tips are scheduled too close
//                 together.
//               </span>
//             </div>
//           </div>
//         );
//         return;
//       }
//     }
//   }
// };






  // useEffect(() => {
  //   try {
  //     const hdrs = dummyData.headers || [];
  //     const rows = dummyData.rows || [];

  //     const transformedRows = rows.map((row) =>
  //       row.map((cell, index) => {
  //         if (hdrs[index] === "Create Date" || hdrs[index] === "Due By") {
  //           if (!cell) return "";
  //           try {
  //             return new Date(cell).toLocaleDateString("en-US", {
  //               year: "numeric",
  //               month: "short",
  //               day: "2-digit",
  //               hour: "2-digit",
  //               minute: "2-digit",
  //             });
  //           } catch {
  //             return cell;
  //           }
  //         }
  //         return cell === "" || cell === null || cell === undefined ? "" : cell;
  //       })
  //     );

  //     setHeaders(hdrs);
  //     setReportDashboardData(transformedRows);
  //   } catch (error) {
  //     console.error("Error loading dummy data:", error);
  //   }
  // }, []);






// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import TableDetailsQuesList from "../../CreateQuestionsPaper/QuestionPaperDetails/TableDetailsQuesList";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import TableDetailsSelectedQues from "../../CreateQuestionsPaper/QuestionPaperDetails/TableDetailsSelectedQuestions";

// function ScheduleTipsOfDays({ dataClient, setMessageBox, messageBox, setIsMessageBoxVisible, setActiveImg, setNoTimeSet, setMessageBoxHeight }) {
//   const navigate = useNavigate();

//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [selectedFrequency, setSelectedFrequency] = useState(null);
//   const [isScheduleOpen, setIsScheduleOpen] = useState(true);

//   const [selectedQuestions, setSelectedQuestions] = useState([]);
//   const [selectedHeaders, setSelectedHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [difficultyCount, setDifficultyCount] = useState({ easy: 0, medium: 0, tough: 0 });
//   const [sectionWiseQuestions, setSectionWiseQuestions] = useState({});
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const [version, setVersion] = useState(0);

//   const toggleScheduleAccordion = () => setIsScheduleOpen((prev) => !prev);

//   return (
//     <div className="create-role-container">
//       {/* Header */}
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Tip of the Day Schedule</span>
//         <div className="create-test-section-btns-container-ques-paper-dels">
//           <button
//             className="create-test-section-btn-ques-paper-del"
//             onClick={() => navigate(-1)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="create-test-section-btn-ques-paper-del"
//             style={{ marginRight: "0px", boxShadow: "0px 4px 4px 0px #00000040" }}
//             onClick={() => navigate("/schedule_tips_of_days")}
//             onMouseEnter={(e) => {
//               e.target.style.backgroundColor = "#fa4741";
//               e.target.style.color = "white";
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.backgroundColor = "white";
//               e.target.style.color = "#424342";
//             }}
//           >
//             NEW
//           </button>
//         </div>
//       </div>

//       {/* Schedule Form */}
//       <div className="display-ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>QUESTION PAPER DETAIL</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleScheduleAccordion}>
//             {isScheduleOpen ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isScheduleOpen && (
//           <div className="accordion-content">
//             <div className="display-test-data-container-ques-paper-del-filter-tags">
//               <div className="display-grid-container-ques-paper-del-filter-tags">
//                 <div className="item2">
//                   <FormInputs
//                     label="From Date"
//                     type="date"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                     placeholder="mm/dd/yyyy"
//                   />
//                 </div>
//                 <div className="item3">
//                   <FormInputs
//                     label="To Date"
//                     type="date"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                     placeholder="mm/dd/yyyy"
//                   />
//                 </div>
//                 <div className="item5">
//                   <DropDown
//                     label="Frequency"
//                     selected={selectedFrequency}
//                     setSelected={(opt) => setSelectedFrequency(opt || null)}
//                     options={[
//                       { label: "Once in a Day",        id: "once_in_1_day"  },
//                       { label: "Once in Two Days",     id: "once_in_2_days" },
//                       { label: "Once in Three Days",   id: "once_in_3_days" },
//                       { label: "Once in Four Days",    id: "once_in_4_days" },
//                       { label: "Once in Five Days",    id: "once_in_5_days" },
//                       { label: "Once in Six Days",     id: "once_in_6_days" },
//                       { label: "Once in a Week",       id: "once_in_week"   },
//                     ]}
//                     isRequired={true}
//                     placeholder="Choose Frequency..."
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Questions */}
//       <div style={{ marginTop: "20px" }}>
//         <div className="display-ques-paper-del-subjects">
//           <div className="accordion-content">
//             <div className="create-ques-paper-ques-list-container-text">
//               <span>QUESTIONS LIST</span>
//             </div>
//             <div className="create-ques-paper-ques-list-container">
//               <TableDetailsQuesList
//                 setMessageBox={setMessageBox}
//                 messageBox={messageBox}
//                 setIsMessageBoxVisible={setIsMessageBoxVisible}
//                 setActiveImg={setActiveImg}
//                 setNoTimeSet={setNoTimeSet}
//                 dataClient={dataClient}
//                 setSelectedQuestions={setSelectedQuestions}
//                 setSelectedHeaders={setSelectedHeaders}
//                 setDifficultyCount={setDifficultyCount}
//                 setReportDashboardData={setReportDashboardData}
//                 reportDashboardData={reportDashboardData}
//                 selectedRows={selectedRows}
//                 setSelectedRows={setSelectedRows}
//                 selectedQuestions={selectedQuestions}
//                 setVersion={setVersion}
//               />
//             </div>

//             <div className="create-ques-paper-ques-selected-container-text">
//               <span>SELECTED QUESTIONS</span>
//             </div>
//             <div className="create-ques-paper-ques-selected-container">
//               <TableDetailsSelectedQues
//                 selectedQuestions={selectedQuestions}
//                 selectedHeaders={selectedHeaders}
//                 setSectionWiseQuestions={setSectionWiseQuestions}
//                 setIsMessageBoxVisible={setIsMessageBoxVisible}
//                 setActiveImg={setActiveImg}
//                 setMessageBox={setMessageBox}
//                 allQuesList={reportDashboardData}
//                 setSelectedQuestions={setSelectedQuestions}
//                 selectedRows={selectedRows}
//                 setSelectedRows={setSelectedRows}
//                 setDifficultyCount={setDifficultyCount}
//                 version={version}
//                 setVersion={setVersion}
//                 sectionWiseQuestions={sectionWiseQuestions}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ScheduleTipsOfDays;











